import React, { useState } from 'react';
import Acknowledgment from './Acknowledgment';
import { Auth } from 'aws-amplify';

const CreateNumber = ({ onClose }) => {
  const [phnoCampaign, setPhnoCampaign] = useState('');
  const [phnoDescription, setPhnoDescription] = useState('');
  const [phnoType, setPhnoType] = useState('normal');
  const [numbType, setNumbType] = useState('static');
  const [countryCode, setCountryCode] = useState('US');
  const [state, setState] = useState(''); // Changed default state to empty string
  const [prefixCode, setPrefixCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [acknowledgment, setAcknowledgment] = useState(null);
  const [isCreateNumberVisible, setIsCreateNumberVisible] = useState(true);
  const [forwardNumber, setForwardNumber] = useState('');
  const [showForwardInput, setShowForwardInput] = useState(false);
  const [source, setSource] = useState('');
  const [showSourceInput, setShowSourceInput] = useState(false);

  const acquirePhone = process.env.REACT_APP_acquirePhone;
  const acquireDIDPhone = process.env.REACT_APP_acquire_did_Phone;

  // Prefix options associated with each state
  const prefixOptionsByState = {
    Alabama: ['205', '251', '256', '334', '659', '938'],
    Alaska: ['907'],
    Arizona: ['480', '520', '602', '623', '928'],
    Arkansas: ['479', '501', '870'],
    California: ['209', '213', '279', '310', '323', '341', '408', '415', '424', '442', '510', '530', '559', '562', '619', '626', '628', '650', '657', '661', '669', '707', '714', '747', '760', '805', '818', '831', '858', '909', '916', '925', '949', '951'],
    Colorado: ['303', '719', '720', '970'],
    Connecticut: ['203', '475', '860', '959'],
    Delaware: ['302'],
    Florida: ['239', '305', '321', '352', '386', '407', '561', '689', '727', '754', '772', '786', '813', '850', '863', '904', '941', '954'],
    Georgia: ['229', '404', '470', '478', '678', '706', '762', '770', '912'],
    Hawaii: ['808'],
    Idaho: ['208', '986'],
    Illinois: ['217', '224', '309', '312', '331', '618', '630', '708', '773', '779', '815', '847', '872'],
    Indiana: ['219', '260', '317', '463', '574', '765', '812', '930'],
    Iowa: ['319', '515', '563', '641', '712'],
    Kansas: ['316', '620', '785', '913'],
    Kentucky: ['270', '364', '502', '606', '859'],
    Louisiana: ['225', '318', '337', '504', '985'],
    Maine: ['207'],
    Maryland: ['227', '240', '301', '410', '443', '667'],
    Massachusetts: ['339', '351', '413', '508', '617', '774', '781', '857', '978'],
    Michigan: ['231', '248', '269', '313', '517', '586', '616', '734', '810', '906', '947', '989'],
    Minnesota: ['218', '320', '507', '612', '651', '763', '952'],
    Mississippi: ['228', '601', '662', '769'],
    Missouri: ['314', '417', '573', '636', '660', '816'],
    Montana: ['406'],
    Nebraska: ['308', '402', '531'],
    Nevada: ['702', '725', '775'],
    NewHampshire: ['603'],
    NewJersey: ['201', '551', '609', '640', '732', '848', '856', '862', '908', '973'],
    NewMexico: ['505', '575'],
    NewYork: ['212', '315', '332', '347', '516', '518', '585', '607', '631', '646', '680', '716', '718', '838', '845', '914', '917', '929', '934'],
    NorthCarolina: ['252', '336', '704', '743', '828', '910', '919', '980', '984'],
    NorthDakota: ['701'],
    Ohio: ['216', '220', '234', '283', '330', '380', '419', '440', '513', '567', '614', '740', '937'],
    Oklahoma: ['405', '539', '572', '580', '918'],
    Oregon: ['458', '503', '541', '971'],
    Pennsylvania: ['215', '223', '267', '272', '412', '445', '484', '570', '610', '717', '724', '814', '878'],
    RhodeIsland: ['401'],
    SouthCarolina: ['803', '839', '843', '854', '864'],
    SouthDakota: ['605'],
    Tennessee: ['423', '615', '629', '731', '865', '901', '931'],
    Texas: ['210', '214', '254', '281', '325', '346', '361', '409', '430', '432', '469', '512', '682', '713', '726', '737', '806', '817', '830', '832', '903', '915', '936', '940', '956', '972', '979'],
    Utah: ['385', '435', '801'],
    Vermont: ['802'],
    Virginia: ['276', '434', '540', '571', '703', '757', '804'],
    Washington: ['206', '253', '360', '425', '509', '564'],
    WestVirginia: ['304', '681'],
    Wisconsin: ['262', '414', '534', '608', '715', '920'],
    Wyoming: ['307']
  
  };

  const handleSubmit = async () => {
    
    if (!phnoCampaign || phnoCampaign.trim() === '') {
      setAcknowledgment({
        status: 'warning',
        message: 'Campaign name cannot be empty',
      });
      return;
    }

    // Validation: If forward input is shown, check number validity
    if (showForwardInput) {
      if (!/^\d{10}$/.test(forwardNumber)) {
        setAcknowledgment({
          status: 'warning',
          message: 'Forward number must be exactly 10 digits.',
        });
        return; // Stop form submission
      }
    }

    setIsLoading(true);
    const forwardEnabled = showForwardInput && /^\d{10}$/.test(forwardNumber);

    const payload = phnoType === 'did' ? {
      phno_campaign: phnoCampaign,
      phno_description: phnoDescription,
      phno_type: numbType,
      country_code: countryCode,
      state_name: state,
      state_prefix_code: prefixCode,
      // forward_enabled: forwardEnabled,
      ...(forwardEnabled && { forward_number: forwardNumber }),
      ...(showSourceInput && { source: source })
    } : {
      phno_campaign: phnoCampaign,
      phno_description: phnoDescription,
      phno_type: numbType,
      // forward_enabled: forwardEnabled,
      ...(forwardEnabled && { forward_number: forwardNumber }),
      ...(showSourceInput && { source: source })
    };

    const apiEndpoint = phnoType === 'did' ? acquireDIDPhone : acquirePhone;

    try {
      const session = await Auth.currentSession();
      const token = session.getIdToken().getJwtToken();

      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      setIsLoading(false);

      setAcknowledgment({
        status: response.status === 200 ? 'success' : 'warning',
        message: data.message,
      });

      if (response.status === 200) {
        setIsCreateNumberVisible(false);
      }
    } catch (error) {
      setIsLoading(false);
      setAcknowledgment({ status: 'warning', message: error.message });
    }
  };


  const handleAcknowledgmentClose = () => {
    setAcknowledgment(null);
    setTimeout(() => {
      window.location.reload();
    }, 18000);
  };

  const renderCampaignInput = () => {
    return (
      <div className="mb-4">
        <label htmlFor="phnoCampaign" className="block text-sm font-medium text-gray-700">
          Campaign Name
        </label>
        <input
          type="text"
          id="phnoCampaign"
          className="mt-1 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          value={phnoCampaign}
          onChange={(e) => setPhnoCampaign(e.target.value)}
        />
      </div>
    );
  };

  const renderDescriptionInput = () => {
    return (
      <div className="mb-4">
        <label htmlFor="phnoDescription" className="block text-sm font-medium text-gray-700">
          Description
        </label>
        <textarea
          id="phnoDescription"
          className="mt-1 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          rows="3"
          value={phnoDescription}
          onChange={(e) => setPhnoDescription(e.target.value)}
        ></textarea>
      </div>
    );
  };

  const renderDIDInputs = () => {
    if (phnoType === 'did') {
      return (
        <>
          {/* <div className="mb-4">
            <label htmlFor="countryCode" className="block text-sm font-medium text-gray-700">
              Country Code
            </label>
            <select
              id="countryCode"
              className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
            >
              <option value="US">US (+1)</option>
            </select>
          </div> */}
          <div className="mb-4">
            <label htmlFor="state" className="block text-sm font-medium text-gray-700">
              State Name
            </label>
            <select
              id="state"
              className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              value={state}
              onChange={(e) => {
                setState(e.target.value);
                setPrefixCode(''); // Reset prefix code when state changes
              }}
            >
              <option value="">Select a state</option> {/* Added placeholder option */}
              {Object.keys(prefixOptionsByState).map((stateOption) => (
                <option key={stateOption} value={stateOption}>
                  {stateOption}
                </option>
              ))}
            </select>
          </div>

          {/* Prefix Code Dropdown Filtered by State */}
          <div className="mb-4">
            <label htmlFor="prefixCode" className="block text-sm font-medium text-gray-700">
              Area Code
            </label>
            <select
              id="prefixCode"
              className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              value={prefixCode}
              onChange={(e) => setPrefixCode(e.target.value)}
            >
              <option value="">Select an area code</option>
              {prefixOptionsByState[state]?.map((prefixOption) => (
                <option key={prefixOption} value={prefixOption}>
                  {prefixOption}
                </option>
              ))}
            </select>
          </div>
        </>
      );
    }
    return null;
  };

  return (
    <>
      {isCreateNumberVisible && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded shadow p-8 w-96">
            <h2 className="text-lg font-bold mb-6">Create Number</h2>
            <form>
              <div className="mb-4">
                <label htmlFor="phnoType" className="block text-sm font-medium text-gray-700">
                  Number Type
                </label>
                <select
                  id="phnoType"
                  className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  value={phnoType}
                  onChange={(e) => setPhnoType(e.target.value)}
                >
                  <option value="normal">Toll-Free Number</option>
                  <option value="did">DID Number</option>
                </select>
              </div>
              {renderCampaignInput()}
              {renderDescriptionInput()}
              {renderDIDInputs()}

              {/* Forward Number Input */}
              <div className="mb-2  flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => setShowForwardInput((prev) => !prev)}
                  className={`w-8 h-4 flex items-center rounded-full  duration-300 ease-in-out
                    ${showForwardInput ? 'bg-green-500' : 'bg-gray-300'}`}
                >
                  <div
                    className={`bg-white w-3 h-3 rounded-full shadow-md transform duration-300 ease-in-out
                      ${showForwardInput ? 'translate-x-5' : 'translate-x-0'}`}
                  />
                </button>
                <span className="text-sm text-gray-700">Enable Forward Number</span>
              </div>
              {showForwardInput &&(
              <div className="mb-2">
                <label htmlFor="forwardNumber" className="block text-sm font-medium text-gray-700">
                  Phone Number
                </label>
                <div className="flex items-center mt-1">
                  <span className="px-3 py-2 border border-gray-300 bg-gray-100 rounded-l-md text-sm text-gray-700">+1</span>
                  <input
                    type="text"
                    id="forwardNumber"
                    name="forwardNumber"
                    maxLength={10}
                    pattern="\d{10}"
                    className="block w-full py-2 px-3 border border-gray-300 rounded-r-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    placeholder="Enter 10-digit number"
                    value={forwardNumber}
                    onChange={(e) => setForwardNumber(e.target.value)}
                  />
                </div>
              </div>
              )}
              {/* Source Input */}
              <div className="mb-2  flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => setShowSourceInput((prev) => !prev)}
                  className={`w-8 h-4 flex items-center rounded-full  duration-300 ease-in-out
                    ${showSourceInput ? 'bg-green-500' : 'bg-gray-300'}`}
                >
                  <div
                    className={`bg-white w-3 h-3 rounded-full shadow-md transform duration-300 ease-in-out
                      ${showSourceInput ? 'translate-x-5' : 'translate-x-0'}`}
                  />
                </button>
                <span className="text-sm text-gray-700">Enable Alternate Source</span>
              </div>
              {showSourceInput &&(
              <div className="mb-2 ">
                <label htmlFor="source" className="block text-sm font-medium text-gray-700">
                  Source
                </label>
                <div className="flex items-center mt-1 mr-2">
                  <input
                    type="text"
                    id="source"
                    name="source"
                    // maxLength={10}
                    // pattern="\d{10}"
                    className="block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    placeholder="Enter source"
                    value={source}
                    onChange={(e) => setSource(e.target.value)}
                  />
                </div>
              </div>
              )}
              <div className="flex justify-end">
                <button
                  type="button"
                  className="mr-2 py-2 px-4 bg-red-500 text-white rounded hover:bg-red-600 focus:outline-none focus:bg-red-600"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="py-2 px-4 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:bg-blue-600"
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? 'Creating...' : 'Create'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {acknowledgment && (
        <Acknowledgment acknowledgment={acknowledgment} onClose={handleAcknowledgmentClose} />
      )}
    </>
  );
};

export default CreateNumber;
